import * as React from 'react';
import { BackButton } from '../back-button/BackButton';
import { Paragraph } from '../paragraph/Paragraph';
import { StickyHeader } from '../sticky-header/StickyHeader';

export interface IContentHeaderProps {
	title: string;
	impersonating: boolean;
	subtext?: string;
	backLocation?: string | (() => void);
	childrenRhs?: JSX.Element;
	label?: JSX.Element;
	sticky: boolean;
	ribbon?: 'mandatory' | 'optional' | 'promo';
	hiddenOnMobile?: 'lhs' | 'rhs';
	detached?: boolean;  // Indicates header is separate from any larger content body (default false)
	onStuckChange?: (isStuck: boolean) => any;
}

const classWithSuffixes = (className: string, suffixes: { [key: string]: boolean }): string => {
	const classes = [className];
	Object.entries(suffixes).map(([suffix, tf]) => tf ? classes.push(className + '--' + suffix) : null);
	return classes.join(' ');
};

interface IContentHeaderState {
	stuck: boolean;
	height: number;
}

const gatedTimeout = () => {
	let prior: any;
	return (fn: any, time: number) => {
		if (prior) clearTimeout(prior);
		prior = setTimeout(fn, time);
	};
};

export class ContentHeaderComponent extends React.Component<IContentHeaderProps, IContentHeaderState> {
	private setTimeout = gatedTimeout();

	constructor(props: IContentHeaderProps) {
		super(props);
		this.state = { stuck: false, height: 0 };
	}

	public onStuckChange(isStuck: boolean) {
		this.setState({ stuck: isStuck });
		if (this.props.onStuckChange) {
			this.props.onStuckChange(isStuck);
		}
	}

	public setPlaceholderHeight(element: HTMLDivElement | null) {
		this.setTimeout(() => {
			if (element && (element.clientHeight > this.state.height)) {
				this.setState({ height: element.clientHeight });
			}
		}, 500);
	}

	public render() {
		const { title, subtext, label, backLocation, childrenRhs, sticky, hiddenOnMobile } = this.props;
		const stuck = sticky && this.state.stuck;
		const attached: boolean = !stuck && !this.props.detached;
		const hasRhs = typeof childrenRhs !== 'undefined';

		return <div className="content-header__placeholder" style={this.state.height ? { height: this.state.height + 'px' } : undefined}>
			<StickyHeader pageYOffset={40} onStuckChange={(isStuck) => sticky ? this.onStuckChange(isStuck) : null}>
				<div
					ref={(r) => this.setPlaceholderHeight(r)}
					className={classWithSuffixes('content-header', { stuck, attached, detached: !attached })}>
					{this.props.ribbon && <div className={`content-header__ribbon ${this.props.ribbon}`} />}
					<div className={classWithSuffixes('content-header__wrap', { stuck })}>
						<div className={`content-header__${hasRhs ? 'lhs' : 'full'} ${hiddenOnMobile === 'lhs' ? 'mobile-hidden' : ''}`}>
							{backLocation ? (<BackButton to={backLocation} />) : (<div className="content-header__pad-title" />)}
							<div className="content-header__title">
								<h1 className={classWithSuffixes('content-header__title-text', { stuck })}>{title}</h1>
								<div className={classWithSuffixes('content-header__subtext__wrapper', { stuck })}>
									{label}
									{subtext && <Paragraph fontSize="d1" additionalClasses={['content-header__title-subtext']}>{subtext}</Paragraph>}
								</div>
							</div>
						</div>
						{hasRhs ? <div className={`content-header__right ${hiddenOnMobile === 'rhs' ? 'mobile-hidden' : ''}`}>
							{childrenRhs}
						</div> : null}

					</div>
				</div>
			</StickyHeader>
		</div>;
	}
}
